












export default {
  props: {
    header: {
      type: String,
      default: ''
    }
  },
  computed: {
    doesTextSlotExist() {
      return this.$slots.default
    }
  }
}
